export default __webpack_public_path__ + "9187712dafcbe8e1a2a28746fa7971ea.png";